import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import RotaProtegida from './components/RotaProtegida';
import CookieBanner from './components/CookieBanner';
import Documentos from './pages/legal/Documentos';

import Login       from './pages/auth/Login';
import LandingPage from './pages/LandingPage';
import Perfil      from './pages/perfil/Perfil';

import SidebarFornecedor from './components/SidebarFornecedor';
import SidebarCliente    from './components/SidebarCliente';
import SidebarAdmin      from './components/SidebarAdmin';

import DashboardFornecedor from './pages/fornecedor/Dashboard';
import Reservas            from './pages/fornecedor/Reservas';
import MeusAnuncios        from './pages/fornecedor/MeusAnuncios';
import PublicarAnuncio     from './pages/fornecedor/PublicarAnuncio';
import Ganhos              from './pages/fornecedor/Ganhos';
import BulkUpload          from './pages/fornecedor/BulkUpload';
import AdicionarFotos      from './pages/fornecedor/AdicionarFotos';

import Explorar        from './pages/cliente/Explorar';
import DetalhesProduto from './pages/cliente/DetalhesProduto';
import Checkout        from './pages/cliente/Checkout';
import MinhasReservas  from './pages/cliente/MinhasReservas';
import Favoritos       from './pages/cliente/Favoritos';
import Notificacoes    from './pages/cliente/Notificacoes';
import Chat            from './pages/chat/Chat';

import OverviewAdmin            from './pages/admin/Overview';
import DashboardAdmin           from './pages/admin/Dashboard';
import TransacoesAdmin          from './pages/admin/Transacoes';
import DisputasAdmin            from './pages/admin/Disputas';
import UtilizadoresAdmin        from './pages/admin/Utilizadores';
import AnunciosAdmin            from './pages/admin/Anuncios';
import FinanceiroAdmin          from './pages/admin/Financeiro';
import FacturasAdmin            from './pages/admin/Facturas';
import WalletsAdmin             from './pages/admin/Wallets';
import PublicidadeAdmin         from './pages/admin/Publicidade';
import ConfiguracoesAdmin       from './pages/admin/Configuracoes';
import FornecedoresConfianca    from './pages/admin/FornecedoresConfianca';

const LF = ({ children }) => <div className="app-layout area-fornecedor"><SidebarFornecedor /><div className="main-content">{children}</div></div>;
const LC = ({ children }) => <div className="app-layout area-cliente"><SidebarCliente    /><div className="main-content">{children}</div></div>;
const LA = ({ children }) => <div className="app-layout area-admin"><SidebarAdmin      /><div className="main-content">{children}</div></div>;

const PR = ({ children, tipo }) => <RotaProtegida tipo={tipo}>{children}</RotaProtegida>;

export default function App() {
  return (
    <BrowserRouter>
      <CookieBanner />
      <Routes>
        {/* Públicas */}
        <Route path="/"           element={<LandingPage />} />
        <Route path="/login"      element={<Login />} />
        <Route path="/documentos" element={<Documentos />} />

        {/* Perfil (qualquer utilizador logado) */}
        <Route path="/perfil" element={<PR><LC><Perfil /></LC></PR>} />

        {/* Fornecedor */}
        <Route path="/fornecedor"                          element={<PR tipo="fornecedor"><LF><DashboardFornecedor /></LF></PR>} />
        <Route path="/fornecedor/reservas"                element={<PR tipo="fornecedor"><LF><Reservas /></LF></PR>} />
        <Route path="/fornecedor/anuncios"                element={<PR tipo="fornecedor"><LF><MeusAnuncios /></LF></PR>} />
        <Route path="/fornecedor/publicar"                element={<PR tipo="fornecedor"><LF><PublicarAnuncio /></LF></PR>} />
        <Route path="/fornecedor/ganhos"                  element={<PR tipo="fornecedor"><LF><Ganhos /></LF></PR>} />
        <Route path="/fornecedor/bulk-upload"             element={<PR tipo="fornecedor"><LF><BulkUpload /></LF></PR>} />
        <Route path="/fornecedor/anuncios/:id/fotos"      element={<PR tipo="fornecedor"><LF><AdicionarFotos /></LF></PR>} />
        <Route path="/fornecedor/chat/:reserva_id"        element={<PR tipo="fornecedor"><LF><Chat /></LF></PR>} />

        {/* Cliente */}
        <Route path="/cliente"               element={<PR><LC><Explorar /></LC></PR>} />
        <Route path="/cliente/produto/:id"   element={<PR><LC><DetalhesProduto /></LC></PR>} />
        <Route path="/cliente/checkout"      element={<PR><LC><Checkout /></LC></PR>} />
        <Route path="/cliente/reservas"      element={<PR><LC><MinhasReservas /></LC></PR>} />
        <Route path="/cliente/favoritos"     element={<PR><LC><Favoritos /></LC></PR>} />
        <Route path="/cliente/chat/:reserva_id"    element={<PR><LC><Chat /></LC></PR>} />
        <Route path="/notificacoes"          element={<PR><LC><Notificacoes /></LC></PR>} />

        {/* Admin */}
        <Route path="/admin"                element={<PR tipo="admin"><LA><OverviewAdmin /></LA></PR>} />
        <Route path="/admin/dashboard"      element={<PR tipo="admin"><LA><DashboardAdmin /></LA></PR>} />
        <Route path="/admin/transacoes"     element={<PR tipo="admin"><LA><TransacoesAdmin /></LA></PR>} />
        <Route path="/admin/disputas"       element={<PR tipo="admin"><LA><DisputasAdmin /></LA></PR>} />
        <Route path="/admin/utilizadores"   element={<PR tipo="admin"><LA><UtilizadoresAdmin /></LA></PR>} />
        <Route path="/admin/anuncios"       element={<PR tipo="admin"><LA><AnunciosAdmin /></LA></PR>} />
        <Route path="/admin/financeiro"     element={<PR tipo="admin"><LA><FinanceiroAdmin /></LA></PR>} />
        <Route path="/admin/facturas"       element={<PR tipo="admin"><LA><FacturasAdmin /></LA></PR>} />
        <Route path="/admin/saldos"                     element={<PR tipo="admin"><LA><WalletsAdmin /></LA></PR>} />
        <Route path="/admin/publicidade"              element={<PR tipo="admin"><LA><PublicidadeAdmin /></LA></PR>} />
        <Route path="/admin/configuracoes"            element={<PR tipo="admin"><LA><ConfiguracoesAdmin /></LA></PR>} />
        <Route path="/admin/fornecedores-confianca"   element={<PR tipo="admin"><LA><FornecedoresConfianca /></LA></PR>} />

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
